import { render } from "./ContactComp.vue?vue&type=template&id=84ed7d10&ts=true"
import script from "./ContactComp.vue?vue&type=script&lang=ts"
export * from "./ContactComp.vue?vue&type=script&lang=ts"

import "./ContactComp.vue?vue&type=style&index=0&id=84ed7d10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__